import * as React from "react";
import { ThemedModalNavBar } from "../../chrome/smart/nav-bar/nav-bar";
import { Wrapper, ItemBox } from "./picker-overlay-style";
import { getLocalizedString } from "common/components/localization";
import type { MenuItem } from "../../lib/menu-item";
import type { RenderEnvironment } from "common/components/types";

interface Props {
    title: string;
    items: string[];
    onFinish: (result: number | undefined) => void;
    renderEnvironment: RenderEnvironment;
}
interface State {
    searchValue: string;
    itemsWithIndex: { item: string; index: number }[];
    filteredItems: { item: string; index: number }[];
}

export default class PickerOverlay extends React.PureComponent<Props, State> {
    public state: State = {
        searchValue: "",
        itemsWithIndex: [],
        filteredItems: [],
    };

    private onSearchChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
        const searchValue = e.target.value.toString().toLowerCase();
        const filteredItems = this.state.itemsWithIndex.filter(item =>
            item.item.toString().toLowerCase().includes(searchValue)
        );
        this.setState({ searchValue, filteredItems });
    };

    private onSearchCleared = () => {
        this.setState({ searchValue: "" });
    };

    public componentWillMount() {
        const itemsWithIndex = this.props.items.map((item, i) => ({ item, index: i }));
        this.setState({ itemsWithIndex });
    }

    public render(): React.ReactNode {
        const { title, onFinish, renderEnvironment } = this.props;
        const { searchValue, itemsWithIndex, filteredItems } = this.state;

        const closeButton: MenuItem = {
            title: getLocalizedString("close", renderEnvironment.appEnvironment.appKind),
            icon: "00-glide-close",
            onClick: () => onFinish(undefined),
            style: "platform-cancel",
        };

        const shouldShowSearch = itemsWithIndex.length >= 10;
        const displayItems = searchValue === "" || !shouldShowSearch ? itemsWithIndex : filteredItems;

        const children = displayItems.map(di => {
            return (
                <ItemBox key={di.index} onClick={() => onFinish(di.index)}>
                    {di.item}
                </ItemBox>
            );
        });

        const className = renderEnvironment.sizeClass === "tablet" ? "modal-anim-tag-tablet" : "modal-anim-tag";
        return (
            <>
                <Wrapper className={className} showSearch={shouldShowSearch}>
                    {children}
                </Wrapper>
                <ThemedModalNavBar
                    renderEnvironment={renderEnvironment}
                    title={title}
                    barButtonItems={[closeButton]}
                    searchValue={shouldShowSearch ? searchValue : undefined}
                    onSearchChanged={shouldShowSearch ? this.onSearchChanged : undefined}
                    onSearchCleared={shouldShowSearch ? this.onSearchCleared : undefined}
                />
            </>
        );
    }
}
